import React, { useMemo, useState } from 'react';
import API_BASE_URL from '../../../../js/urlHelper';
import { fetchWithAuth } from '../../../../js/authToken';
import { toast } from 'react-toastify';
import LoadingScreen from '../../../Reutilizables/FetchWithGif';
import ClienteSearch from './components/ClienteSearch';
import PrestamosList from './components/PrestamosList';
import PagoCuotaModal from './components/modals/PagoCuotaModal';
import CapturaModal from './components/modals/CapturaModal';
import ComprobanteModal from './components/modals/ComprobanteModal';
import ComprobantesParcialesModal from './components/modals/ComprobantesParcialesModal';
import CancelarPrestamoModal from './components/modals/CancelarPrestamoModal';
import ReprogramarPrestamoModal from './components/modals/ReprogramarPrestamoModal';
import ConvenioPrestamoModal from './components/modals/ConvenioPrestamoModal';
import ConfirmationModal from './components/modals/ConfirmationModal';
import CapturaAbonoModal from './components/modals/CapturaAbonoModal';
import ReducirMoraModal from './components/modals/ReducirMoraModal';
import { format, parseISO } from 'date-fns';
import { rangoFechaPago } from '../../../../js/fechaPagoHelper';

export default function PagoComponent() {
  const toNumber = (value) => {
    const num = Number(value);
    return Number.isFinite(num) ? num : 0;
  };

  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState(null);
  const [cuotasPendientes, setCuotasPendientes] = useState([]);
  const [selectedCuota, setSelectedCuota] = useState(null);
  const [selectedPrestamo, setSelectedPrestamo] = useState(null);
  const [selectedPrestamoCuotas, setSelectedPrestamoCuotas] = useState([]);
  const [formData, setFormData] = useState({
    idCuota: '',
    idCliente: '',
    monto_pagado: '',
    numero_operacion: '',
    observaciones: '',
    porcentaje_reduccion: ''
  });
  const [cancelarForm, setCancelarForm] = useState({
    idPrestamo: '',
    idCliente: '',
    monto_pagado: '',
    numero_operacion: '',
    observaciones: ''
  });
  const [reprogramarForm, setReprogramarForm] = useState({
    idPrestamo: '',
    tasa_interes: '1',
    observaciones: ''
  });
  const [convenioForm, setConvenioForm] = useState({
    idPrestamo: '',
    solo_capital: false,
    excluir_mora: false,
    cuotas_convenio: '',
    fecha_inicio: '',
    frecuencia: '',
    tasa_interes: '1',
    observaciones: ''
  });
  const [calculandoMontoCancelacion, setCalculandoMontoCancelacion] = useState(false);
  const [showCuotaModal, setShowCuotaModal] = useState(false);
  const [showCancelarModal, setShowCancelarModal] = useState(false);
  const [showReprogramarModal, setShowReprogramarModal] = useState(false);
  const [showConvenioModal, setShowConvenioModal] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [showCapturaModal, setShowCapturaModal] = useState(false);
  const [showComprobanteModal, setShowComprobanteModal] = useState(false);
  const [showComprobantesParcialesModal, setShowComprobantesParcialesModal] = useState(false);
  const [pagosMultiples, setPagosMultiples] = useState({ prestamo: null, cuota: null, pagos: [] });
  const [modalContent, setModalContent] = useState({ capturaUrl: '', comprobanteUrl: '' });
  const [modalTitle, setModalTitle] = useState('');
  const [modalError, setModalError] = useState('');
  const [confirmationAction, setConfirmationAction] = useState(null);
  const [errors, setErrors] = useState({});
  const [showCapturaAbonoModal, setShowCapturaAbonoModal] = useState(false);
  const [showReducirMoraModal, setShowReducirMoraModal] = useState(false);
  const [loadingComprobantes, setLoadingComprobantes] = useState(false);

  const ensureHttpsUrl = (url) => {
    if (!url) return url;
    if (url.includes('localhost') || url.includes('127.0.0.1')) {
      return url;
    }
    if (url.startsWith('http://')) {
      return url.replace('http://', 'https://');
    }
    return url;
  };

  const convenioTotals = useMemo(() => {
    if (!selectedPrestamo || !selectedPrestamoCuotas.length) {
      return {
        basePendiente: 0,
        moraPendiente: 0,
        interesNuevo: 0,
        total: 0,
        valorCuota: 0,
        cuotasPendientes: 0
      };
    }

    const cuotasObjetivo = selectedPrestamoCuotas.filter(
      (cuota) => !['pagado', 'prepagado'].includes(cuota.estado)
    );

    if (cuotasObjetivo.length === 0) {
      return {
        basePendiente: 0,
        moraPendiente: 0,
        interesNuevo: 0,
        total: 0,
        valorCuota: 0,
        cuotasPendientes: 0
      };
    }

    let basePendiente = 0;
    let moraPendiente = 0;

    cuotasObjetivo.forEach((cuota) => {
      const pagosAplicados = Array.isArray(cuota.pagos) ? cuota.pagos : [];
      const pagadoCuota = pagosAplicados.reduce(
        (acc, pago) => acc + (Number(pago.pago_aplicado_cuota) || 0),
        0
      );
      const pagadoMora = pagosAplicados.reduce(
        (acc, pago) => acc + (Number(pago.pago_aplicado_mora) || 0),
        0
      );

      const capitalBase = toNumber(cuota.capital);
      const interesBase = convenioForm.solo_capital ? 0 : toNumber(cuota.interes);
      const moraBase = toNumber(cuota.mora ?? cuota.monto_mora ?? cuota.cargo_mora);

      // Incluimos "otros"; si el backend no lo envía, calculamos la diferencia con monto.
      const otrosBaseDirect =
        toNumber(cuota.otros ?? cuota.monto_otros ?? cuota.otros_monto ?? cuota.otros_concepto);
      const montoCuota = toNumber(cuota.monto);
      const otrosBaseCalculado = Math.max(0, montoCuota - capitalBase - interesBase);
      const otrosBase = otrosBaseDirect !== 0 ? otrosBaseDirect : otrosBaseCalculado;

      basePendiente += Math.max(0, capitalBase + interesBase + otrosBase - pagadoCuota);
      moraPendiente += convenioForm.excluir_mora
        ? 0
        : Math.max(0, moraBase - pagadoMora);
    });

    const tasa = parseFloat(convenioForm.tasa_interes) || 0;
    const interesNuevo = Math.max(0, basePendiente * (tasa / 100));
    const total = basePendiente + moraPendiente + interesNuevo;
    const cuotasObjetivoCount = Number(convenioForm.cuotas_convenio) || 0;
    const valorCuota = cuotasObjetivoCount > 0 ? total / cuotasObjetivoCount : 0;

    return {
      basePendiente: Math.max(0, basePendiente),
      moraPendiente: convenioForm.excluir_mora ? 0 : Math.max(0, moraPendiente),
      interesNuevo,
      total,
      valorCuota,
      cuotasPendientes: cuotasObjetivo.length
    };
  }, [convenioForm, selectedPrestamo, selectedPrestamoCuotas]);

  const handleSubirCapturaAbono = (prestamo) => {
    setSelectedPrestamo(prestamo.prestamo);
    setShowCapturaAbonoModal(true);
  };

  const handleReducirMora = (prestamo, cuota) => {
    setSelectedPrestamo(prestamo);
    setSelectedCuota(cuota);
    setFormData({
      idCuota: cuota.idCuota,
      idCliente: selectedCliente.idUsuario,
      porcentaje_reduccion: ''
    });
    setShowReducirMoraModal(true);
  };

  const validateReducirMoraForm = () => {
    const newErrors = {};
    if (!formData.porcentaje_reduccion || parseFloat(formData.porcentaje_reduccion) < 1 || parseFloat(formData.porcentaje_reduccion) > 100) {
      newErrors.porcentaje_reduccion = 'El porcentaje de reducción debe estar entre 1% y 100%';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const resetSelection = () => {
    setSelectedCliente(null);
    setCuotasPendientes([]);
    setSelectedCuota(null);
    setSelectedPrestamo(null);
    setSelectedPrestamoCuotas([]);
    setShowCuotaModal(false);
    setShowCancelarModal(false);
    setShowReprogramarModal(false);
    setShowConvenioModal(false);
    setShowConfirmationModal(false);
    setShowCapturaModal(false);
    setShowComprobanteModal(false);
    setShowCapturaAbonoModal(false);
    setShowReducirMoraModal(false);
    setErrors({});
    setModalContent({ capturaUrl: '', comprobanteUrl: '' });
    setModalTitle('');
    setModalError('');
  };

  const handleSearch = async () => {
    if (!searchQuery.trim()) {
      toast.error('Ingrese un criterio de búsqueda');
      return;
    }

    resetSelection();
    setLoading(true);
    try {
      const response = await fetchWithAuth(
        `${API_BASE_URL}/api/admin/pagos/buscar-clientes?query=${encodeURIComponent(searchQuery)}`,
        { method: 'GET' }
      );

      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || 'Error al buscar clientes');
      }

      setSearchResults(data.data || []);
      if (data.data && data.data.length === 0) {
        toast.info('No se encontraron clientes con ese criterio');
      }
    } catch (error) {
      console.error('Error:', error);
      toast.error(error.message || 'Error al buscar clientes');
    } finally {
      setLoading(false);
    }
  };

  const handleSelectCliente = async (cliente) => {
    setSelectedCliente(cliente);
    setSearchResults([]);
    setSearchQuery(`${cliente.nombre} ${cliente.apellidoPaterno} ${cliente.apellidoMaterno} - ${cliente.dni}`);
    setLoading(true);

    try {
      const timestamp = new Date().getTime();
      
      const response = await fetchWithAuth(
        `${API_BASE_URL}/api/admin/pagos/cuotas-pendientes/${cliente.idUsuario}?_t=${timestamp}`,
        { 
          method: 'GET',
          headers: {
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Pragma': 'no-cache',
            'Expires': '0'
          }
        }
      );

      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || 'Error al obtener cuotas pendientes');
      }

      if (!data.success) {
        toast.info(data.message || 'El cliente no tiene cuotas pendientes');
        setCuotasPendientes([]);
        return;
      }
      const prestamos = data.data.prestamos || [];
      prestamos.forEach((prestamo, index) => {
        prestamo.cuotas.forEach((cuota) => {
          if (cuota.mensaje) {
            if (
              cuota.mensaje.includes('Cuota vencida') ||
              cuota.mensaje.includes('Cuota ajustada') ||
              cuota.mensaje.includes('Mora aplicada')
            ) {
              toast.warn(
                `Préstamo ${index + 1}, Cuota ${cuota.numero_cuota}: ${cuota.mensaje}`,
                { autoClose: 5000 }
              );
            } else {
              toast.info(
                `Préstamo ${index + 1}, Cuota ${cuota.numero_cuota}: ${cuota.mensaje}`,
                { autoClose: 5000 }
              );
            }
          }
        });
      });

      setCuotasPendientes(prestamos);
    } catch (error) {
      console.error('Error:', error);
      toast.error(error.message || 'Error al obtener cuotas pendientes');
      setCuotasPendientes([]);
    } finally {
      setLoading(false);
    }
  };

  const handlePagarCuota = (prestamo, cuota) => {
    setSelectedPrestamo(prestamo);
    setSelectedCuota(cuota);

    const montoAPagar = (() => {
      const saldo = parseFloat(cuota.saldo_pendiente ?? NaN);
      if (!Number.isNaN(saldo)) return Math.max(0, saldo);
      const base = parseFloat(cuota.monto_a_pagar ?? cuota.monto ?? 0) || 0;
      const excedente = parseFloat(cuota.excedente_anterior ?? 0) || 0;
      return Math.max(0, base - excedente);
    })();

    setFormData({
      idCuota: cuota.idCuota,
      idCliente: selectedCliente.idUsuario,
      monto_pagado: montoAPagar.toFixed(2),
      numero_operacion: '',
      observaciones: '',
      fecha_pago: rangoFechaPago().max
    });
    setShowCuotaModal(true);
  };

  const handleVerCaptura = async (prestamo, cuota) => {
    setSelectedPrestamo(prestamo);
    setSelectedCuota(cuota);
    setLoading(true);
    setModalContent({ capturaUrl: '', comprobanteUrl: '' });
    setModalError('');
    setModalTitle(`Captura de Pago - Cuota #${cuota.numero_cuota}`);

    try {
      const response = await fetchWithAuth(
        `${API_BASE_URL}/api/admin/pagos/captura/${cuota.idCuota}`,
        { method: 'GET' }
      );
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || 'Error al obtener captura de pago');
      }

      const capturaUrl = data.capturapago_url ? ensureHttpsUrl(data.capturapago_url) : '';
      if (!capturaUrl) {
        throw new Error('No hay captura de pago disponible');
      }

      setModalContent({ capturaUrl, comprobanteUrl: '' });
      setShowCapturaModal(true);
    } catch (error) {
      console.error('Error:', error);
      setModalError(error.message || 'Error al obtener captura de pago');
      setShowCapturaModal(true);
    } finally {
      setLoading(false);
    }
  };

  const handleVerComprobante = async (prestamo, cuota) => {
    setSelectedPrestamo(prestamo);
    setSelectedCuota(cuota);
    setLoading(true);
    setModalContent({ capturaUrl: '', comprobanteUrl: '' });
    setModalError('');
    setModalTitle(`Comprobante de Pago - Cuota #${cuota.numero_cuota}`);

    try {
      const response = await fetchWithAuth(
        `${API_BASE_URL}/api/admin/pagos/comprobante/${cuota.idCuota}`,
        { method: 'GET' }
      );
      const data = await response.json();
      if (!response.ok) {
        setModalError(data.message || 'Error al obtener comprobante de pago');
        setShowComprobanteModal(true);
        toast.error(data.message || 'Error al obtener comprobante de pago');
        return;
      }

      const comprobanteUrl = data.comprobante_url ? ensureHttpsUrl(data.comprobante_url) : '';
      if (!comprobanteUrl) {
        setModalError('No hay comprobante de pago disponible');
        setShowComprobanteModal(true);
        toast.warning('No hay comprobante de pago disponible');
        return;
      }

      setModalContent({ capturaUrl: '', comprobanteUrl });
      setShowComprobanteModal(true);
    } catch (error) {
      console.error('Error:', error);
      setModalError(error.message || 'Error al obtener comprobante de pago');
      setShowComprobanteModal(true);
    } finally {
      setLoading(false);
    }
  };

  const handleVerComprobantesMultiples = async (prestamo, cuota, pagosAplicados) => {
    setSelectedPrestamo(prestamo);
    setSelectedCuota(cuota);
    setLoadingComprobantes(true);
    setShowComprobantesParcialesModal(true);

    try {
      // Obtener los comprobantes de todos los pagos
      const pagosConComprobantes = await Promise.all(
        pagosAplicados.map(async (pago) => {
          try {
            const response = await fetchWithAuth(
              `${API_BASE_URL}/api/admin/pagos/comprobante-por-pago/${pago.idPago}`,
              { method: 'GET' }
            );
            const data = await response.json();
            if (response.ok && data.comprobante_url) {
              return {
                ...pago,
                comprobante_url: ensureHttpsUrl(data.comprobante_url)
              };
            }
            return {
              ...pago,
              comprobante_url: null
            };
          } catch (error) {
            console.error(`Error al obtener comprobante del pago ${pago.idPago}:`, error);
            return {
              ...pago,
              comprobante_url: null
            };
          }
        })
      );

      setPagosMultiples({
        prestamo,
        cuota,
        pagos: pagosConComprobantes
      });
    } catch (error) {
      console.error('Error:', error);
      toast.error('Error al cargar los comprobantes');
    } finally {
      setLoadingComprobantes(false);
    }
  };

  const handleCancelarPrestamo = (prestamo) => {
    // Calcular excedentes disponibles de todo el préstamo
    const excedentesDisponibles = prestamo.cuotas
      .filter(cuota => ['pagado', 'prepagado'].includes(cuota.estado))
      .reduce((total, cuota) => {
        const pagosAplicados = Array.isArray(cuota.pagos) ? cuota.pagos : [];
        const excedentesCuota = pagosAplicados.reduce((acc, pago) => {
          const excedente = parseFloat(pago.excedente ?? 0) || 0;
          return acc + excedente;
        }, 0);
        return total + excedentesCuota;
      }, 0);

    // Calcular monto pendiente de todas las cuotas sin aplicar excedentes aún
    const montoPendienteSinExcedentes = prestamo.cuotas
      .filter(cuota => !['pagado', 'prepagado'].includes(cuota.estado))
      .reduce((total, cuota) => {
        // Priorizar saldo_pendiente si está disponible
        const saldo = parseFloat(cuota.saldo_pendiente ?? NaN);
        if (!Number.isNaN(saldo)) {
          return total + Math.max(0, saldo);
        }

        // Calcular el saldo pendiente considerando pagos parciales
        const montoCuota = parseFloat(cuota.monto ?? 0) || 0;
        const moraActual = parseFloat(cuota.mora ?? 0) || 0;
        const excedenteAnterior = parseFloat(cuota.excedente_anterior ?? 0) || 0;
        
        // Calcular total pagado de esta cuota
        const pagosAplicados = Array.isArray(cuota.pagos) ? cuota.pagos : [];
        const totalPagado = pagosAplicados.reduce((acc, pago) => {
          const pagoACuota = parseFloat(pago.pago_aplicado_cuota ?? 0) || 0;
          const pagoAMora = parseFloat(pago.pago_aplicado_mora ?? 0) || 0;
          return acc + pagoACuota + pagoAMora;
        }, 0);
        
        // Total a pagar = (cuota + mora - excedente) - pagos realizados
        const montoTotalOriginal = montoCuota + moraActual - excedenteAnterior;
        const saldoPendiente = Math.max(0, montoTotalOriginal - totalPagado);
        
        return total + saldoPendiente;
      }, 0);

    const excedentesAplicadosPendientes = prestamo.cuotas
      .filter(cuota => !['pagado', 'prepagado'].includes(cuota.estado))
      .reduce((total, cuota) => {
        const excedenteAnterior = parseFloat(cuota.excedente_anterior ?? 0) || 0;
        return total + excedenteAnterior;
      }, 0);

    const excedentesNoAplicados = Math.max(0, excedentesDisponibles - excedentesAplicadosPendientes);
    const montoPendienteFinal = Math.max(0, montoPendienteSinExcedentes - excedentesNoAplicados);

    setSelectedPrestamo(prestamo.prestamo);
    setCancelarForm({
      idPrestamo: prestamo.prestamo.idPrestamo,
      idCliente: selectedCliente.idUsuario,
      monto_pagado: montoPendienteFinal.toFixed(2),
      numero_operacion: '',
      observaciones: '',
      fecha_pago: rangoFechaPago().max
    });
    setShowCancelarModal(true);
  };

  // La mora depende de la fecha de pago: el backend recalcula el monto requerido sin registrar nada
  const handleCancelarFechaPagoChange = async (fecha) => {
    setCancelarForm(prev => ({ ...prev, fecha_pago: fecha }));

    const { min, max } = rangoFechaPago();
    if (!fecha || fecha < min || fecha > max) return;

    setCalculandoMontoCancelacion(true);
    try {
      const response = await fetchWithAuth(
        `${API_BASE_URL}/api/admin/pagos/cancelacion-total`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            ...cancelarForm,
            idCliente: cancelarForm.idCliente || selectedCliente?.idUsuario,
            fecha_pago: fecha,
            simular: true
          })
        }
      );

      const data = await response.json();
      if (!response.ok) {
        toast.error(data.message || data.error || 'No se pudo calcular el monto a la fecha seleccionada');
        return;
      }

      const montoRequerido = Number(data.data?.monto_requerido ?? NaN);
      if (Number.isFinite(montoRequerido)) {
        setCancelarForm(prev => (
          prev.fecha_pago === fecha ? { ...prev, monto_pagado: montoRequerido.toFixed(2) } : prev
        ));
      }
    } catch (error) {
      console.error('Error:', error);
      toast.error('No se pudo calcular el monto a la fecha seleccionada');
    } finally {
      setCalculandoMontoCancelacion(false);
    }
  };

  const handleReprogramarPrestamo = (prestamo) => {
    setSelectedPrestamo(prestamo.prestamo);
    setReprogramarForm({
      idPrestamo: prestamo.prestamo.idPrestamo,
      tasa_interes: '1',
      observaciones: ''
    });
    setShowReprogramarModal(true);
  };

  const handleConvenioPrestamo = (prestamo) => {
    setSelectedPrestamo(prestamo.prestamo);
    setSelectedPrestamoCuotas(prestamo.cuotas || []);

    const cuotasPendientesConvenio = (prestamo.cuotas || []).filter(
      cuota => !['pagado', 'prepagado'].includes(cuota.estado)
    );

    const cuotasSugeridas = cuotasPendientesConvenio.length > 0
      ? cuotasPendientesConvenio.length
      : prestamo.prestamo.cuotas;

    const fechaSugerida = new Date().toISOString().slice(0, 10);

    setConvenioForm({
      idPrestamo: prestamo.prestamo.idPrestamo,
      solo_capital: false,
      excluir_mora: false,
      cuotas_convenio: cuotasSugeridas,
      fecha_inicio: fechaSugerida,
      frecuencia: prestamo.prestamo.frecuencia || 'semanal',
      tasa_interes: '1',
      observaciones: ''
    });
    setErrors({});
    setShowConvenioModal(true);
  };

  const handleRechazarPagoPrepagado = async ({ idCliente, idPrestamo, idCuota, motivo }) => {
    setLoading(true);
    try {
      const response = await fetchWithAuth(
        `${API_BASE_URL}/api/admin/pagos/rechazar-prepago/${idCuota}`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ idCliente, idPrestamo, idCuota, motivo })
        }
      );

      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || 'Error al rechazar el pago');
      }

      toast.success('Pago rechazado correctamente');
      // Refresh cuotas list
      if (selectedCliente) {
        await handleSelectCliente(selectedCliente);
      }
    } catch (error) {
      console.error('Error:', error);
      throw error; // Propagate error to CapturaModal
    } finally {
      setLoading(false);
    }
  };

  const validatePaymentForm = () => {
    const newErrors = {};
    if (!formData.monto_pagado || parseFloat(formData.monto_pagado) <= 0) {
      newErrors.monto_pagado = 'Ingrese un monto válido';
    }
    if (!formData.idCliente) {
      newErrors.idCliente = 'Cliente no seleccionado';
    }
    if (!formData.numero_operacion.trim()) {
      newErrors.numero_operacion = 'El número de operación es obligatorio';
    } else if (!/^\d+$/.test(formData.numero_operacion.trim())) {
      newErrors.numero_operacion = 'El número de operación debe contener solo números';
    }
    const { min, max } = rangoFechaPago();
    if (!formData.fecha_pago || formData.fecha_pago < min || formData.fecha_pago > max) {
      newErrors.fecha_pago = 'Seleccione una fecha de pago válida';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validateCancelForm = () => {
    const newErrors = {};
    if (!cancelarForm.monto_pagado || parseFloat(cancelarForm.monto_pagado) <= 0) {
      newErrors.monto_pagado = 'Ingrese un monto válido';
    }
    const { min, max } = rangoFechaPago();
    if (!cancelarForm.fecha_pago || cancelarForm.fecha_pago < min || cancelarForm.fecha_pago > max) {
      newErrors.fecha_pago = 'Seleccione una fecha de pago válida';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validateReprogramarForm = () => {
    const newErrors = {};
    if (!reprogramarForm.tasa_interes || parseFloat(reprogramarForm.tasa_interes) < 1 || parseFloat(reprogramarForm.tasa_interes) > 5) {
      newErrors.tasa_interes = 'La tasa de interés debe estar entre 1% y 5%';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validateConvenioForm = () => {
    const newErrors = {};
    const isoDate = /^\d{4}-\d{2}-\d{2}$/;

    if (!convenioForm.cuotas_convenio || Number(convenioForm.cuotas_convenio) <= 0) {
      newErrors.cuotas_convenio = 'Ingrese la cantidad de cuotas para el convenio';
    }

    if (!convenioForm.fecha_inicio || !isoDate.test(convenioForm.fecha_inicio)) {
      newErrors.fecha_inicio = 'Ingrese una fecha de inicio valida';
    }

    if (!convenioForm.frecuencia) {
      newErrors.frecuencia = 'Seleccione la frecuencia de cuotas';
    }

    const tasa = parseFloat(convenioForm.tasa_interes);
    if (Number.isNaN(tasa) || tasa < 1 || tasa > 5) {
      newErrors.tasa_interes = 'La tasa debe estar entre 1% y 5%';
    }

    if (!convenioTotals.cuotasPendientes) {
      newErrors.cuotas_convenio = 'No hay cuotas pendientes para generar convenio';
    }

    if (convenioTotals.total <= 0) {
      newErrors.generalConvenio = 'El monto total del convenio debe ser mayor a 0';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleConfirmAction = (action) => {
    let isValid = false;
    if (action === 'pagar-cuota') {
      isValid = validatePaymentForm();
    } else if (action === 'reducir-mora') {
      isValid = validateReducirMoraForm();
    } else if (action === 'cancelar-prestamo') {
      isValid = validateCancelForm();
    } else if (action === 'reprogramar-prestamo') {
      isValid = validateReprogramarForm();
    } else if (action === 'convenio-prestamo') {
      isValid = validateConvenioForm();
    }
    if (isValid) {
      setConfirmationAction(action);
      setShowConfirmationModal(true);
    }
  };

  const registrarReducirMora = async () => {
    setLoading(true);
    try {
      const response = await fetchWithAuth(
        `${API_BASE_URL}/api/admin/pagos/reducir-mora`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            idCuota: formData.idCuota,
            porcentaje_reduccion: parseFloat(formData.porcentaje_reduccion)
          })
        }
      );
      const data = await response.json();
      if (!response.ok) {
        toast.error(data.message || 'Error al aplicar la reducción de mora');
        return;
      }
      toast.success('Reducción de mora aplicada correctamente');
      setShowReducirMoraModal(false);
      setShowConfirmationModal(false);
      if (selectedCliente) {
        await handleSelectCliente(selectedCliente);
      }
    } catch (error) {
      console.error('Error:', error);
      toast.error(error.message || 'Error al aplicar la reducción de mora');
    } finally {
      setLoading(false);
    }
  };

  const handleConfirmarPagoPrepagado = async () => {
    setLoading(true);
    try {
      const response = await fetchWithAuth(
        `${API_BASE_URL}/api/admin/pagos/confirmar-prepago/${selectedCuota.idCuota}`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' }
        }
      );

      const data = await response.json();
      if (!response.ok) {
        toast.error(data.message || 'Error al confirmar el pago');
        return;
      }

      if (data.data && data.data.cuota) {
        const estadoCuota = data.data.cuota.estado;
        console.log('Estado de cuota prepagada después de confirmar:', estadoCuota);
        
        if (estadoCuota !== 'pagado') {
          console.error('ADVERTENCIA: Estado de cuota no es "pagado":', estadoCuota);
          toast.warning('Pago confirmado, pero verifique el estado en la base de datos');
        }
      }

      setSelectedCuota({ ...selectedCuota, estado: 'pagado' });

      setShowCapturaModal(false);
      setModalContent({ capturaUrl: '', comprobanteUrl: '' });
      setModalTitle('');
      setModalError('');
      
      toast.success('Pago confirmado correctamente');

      if (data.data && data.data.comprobante_url) {
        const comprobanteUrl = ensureHttpsUrl(data.data.comprobante_url);
        setModalContent({ capturaUrl: '', comprobanteUrl });
        setModalTitle(`Comprobante de Pago - Cuota #${selectedCuota.numero_cuota}`);
        setModalError('');
        setShowComprobanteModal(true);
      }
    } catch (error) {
      console.error('Error:', error);
      toast.error(error.message || 'Error al confirmar el pago');
      setModalError(error.message || 'Error al confirmar el pago');
    } finally {
      setLoading(false);
    }
    
    // Recargar datos en background sin loading screen
    if (selectedCliente) {
      handleSelectCliente(selectedCliente);
    }
  };

  const registrarPagoCuota = async () => {
    setLoading(true);
    try {
      const response = await fetchWithAuth(
        `${API_BASE_URL}/api/admin/pagos/cuota`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(formData)
        }
      );

      const data = await response.json();
      if (!response.ok) {
        toast.error(data.message || data.error || 'Error al registrar el pago');
        return;
      }

      let estadoVerificado = false;
      const maxIntentos = 5;
      const estadosValidos = ['pendiente', 'pagado', 'vence_hoy', 'vencido', 'prepagado'];
      
      if (data.data && data.data.cuota) {
        const estadoCuota = data.data.cuota.estado;
        if (estadosValidos.includes(estadoCuota)) {
          estadoVerificado = true;
        }
      }

      if (!estadoVerificado) {
        for (let intento = 1; intento <= maxIntentos && !estadoVerificado; intento++) {
          await new Promise(resolve => setTimeout(resolve, 500 * intento));
          
          try {
            const timestamp = new Date().getTime();
            const verificacionResponse = await fetchWithAuth(
              `${API_BASE_URL}/api/admin/pagos/cuotas-pendientes/${selectedCliente.idUsuario}?_t=${timestamp}`,
              { 
                method: 'GET',
                headers: { 
                  'Cache-Control': 'no-cache, no-store, must-revalidate',
                  'Pragma': 'no-cache',
                  'Expires': '0'
                }
              }
            );
            
            const verificacionData = await verificacionResponse.json();
            
            if (verificacionResponse.ok && verificacionData.success) {
              const prestamoActualizado = verificacionData.data.prestamos?.find(
                p => p.prestamo.idPrestamo === selectedPrestamo.idPrestamo
              );
              
              const cuotaActualizada = prestamoActualizado?.cuotas?.find(
                c => c.idCuota === formData.idCuota
              );
              
              if (cuotaActualizada && estadosValidos.includes(cuotaActualizada.estado)) {
                estadoVerificado = true;
                break;
              }
            }
          } catch (verifyError) {
            console.error(`Error en verificación intento ${intento}:`, verifyError);
          }
        }
        
        if (!estadoVerificado) {
          toast.warning(
            'Pago registrado, pero hay inconsistencias. Por favor, verifique el estado manualmente.',
            { autoClose: 8000 }
          );
        }
      }

      setShowCuotaModal(false);
      setShowConfirmationModal(false);
      
      toast.success('Pago registrado correctamente');
      
      if (data.data && data.data.comprobante_url) {
        const comprobanteUrl = ensureHttpsUrl(data.data.comprobante_url);
        setModalContent({ capturaUrl: '', comprobanteUrl });
        setModalTitle(`Comprobante de Pago - Cuota #${selectedCuota.numero_cuota}`);
        setModalError('');
        setShowComprobanteModal(true);
      }
      
    } catch (error) {
      console.error('Error al registrar pago:', error);
      toast.error(error.message || 'Error al registrar el pago');
    } finally {
      setLoading(false);
    }
    
    // Recargar datos en background sin loading screen
    if (selectedCliente) {
      handleSelectCliente(selectedCliente);
    }
  };

  const registrarCancelacionPrestamo = async () => {
    if (!cancelarForm.idCliente && !selectedCliente?.idUsuario) {
      toast.error('No se ha seleccionado un cliente válido');
      return;
    }

    setLoading(true);
    try {
      const requestData = {
        ...cancelarForm,
        idCliente: cancelarForm.idCliente || selectedCliente.idUsuario
      };

      const response = await fetchWithAuth(
        `${API_BASE_URL}/api/admin/pagos/cancelacion-total`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(requestData)
        }
      );

      const data = await response.json();
      if (!response.ok) {
        toast.error(data.message || data.error || 'Error al cancelar el préstamo');
        return;
      }

      setShowCancelarModal(false);
      setShowConfirmationModal(false);
      
      toast.success('Préstamo cancelado correctamente');
      
      if (data.data && data.data.comprobante_url) {
        const comprobanteUrl = ensureHttpsUrl(data.data.comprobante_url);
        setModalContent({ capturaUrl: '', comprobanteUrl });
        setModalTitle(`Comprobante de Cancelación Total - Préstamo #${selectedPrestamo.idPrestamo}`);
        setModalError('');
        setShowComprobanteModal(true);
      }
    } catch (error) {
      console.error('Error:', error);
      toast.error(error.message || 'Error al cancelar el préstamo');
    } finally {
      setLoading(false);
    }
    
    // Recargar datos en background sin loading screen
    if (selectedCliente) {
      handleSelectCliente(selectedCliente);
    }
  };

  const registrarReprogramacion = async () => {
    setLoading(true);
    try {
      const response = await fetchWithAuth(
        `${API_BASE_URL}/api/admin/pagos/reprogramar-prestamo`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(reprogramarForm)
        }
      );

      const data = await response.json();
      if (!response.ok) {
        toast.error(data.message || data.error || 'Error al reprogramar el préstamo');
        return;
      }

      setShowReprogramarModal(false);
      setShowConfirmationModal(false);
      
      toast.success('Préstamo reprogramado correctamente');
      
      if (data.data && data.data.comprobante_url) {
        const comprobanteUrl = ensureHttpsUrl(data.data.comprobante_url);
        setModalContent({ capturaUrl: '', comprobanteUrl });
        setModalTitle(`Comprobante de Reprogramación - Préstamo #${selectedPrestamo.idPrestamo}`);
        setModalError('');
        setShowComprobanteModal(true);
      }
    } catch (error) {
      console.error('Error:', error);
      toast.error(error.message || 'Error al reprogramar el préstamo');
    } finally {
      setLoading(false);
    }
    
    if (selectedCliente) {
      handleSelectCliente(selectedCliente);
    }
  };

  const registrarConvenio = async () => {
    setLoading(true);
    try {
      const payload = {
        ...convenioForm,
        cuotas_convenio: Number(convenioForm.cuotas_convenio),
        tasa_interes: parseFloat(convenioForm.tasa_interes)
      };

      const response = await fetchWithAuth(
        `${API_BASE_URL}/api/admin/pagos/convenio-prestamo`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        }
      );

      const data = await response.json();
      if (!response.ok) {
        if (response.status === 422 && data?.errors) {
          setErrors(data.errors);
        }
        toast.error(data.message || data.error || 'Error al registrar el convenio');
        return;
      }

      setShowConvenioModal(false);
      setShowConfirmationModal(false);
      
      toast.success('Convenio registrado correctamente');
      
      if (data.data && data.data.comprobante_url) {
        const comprobanteUrl = ensureHttpsUrl(data.data.comprobante_url);
        setModalContent({ capturaUrl: '', comprobanteUrl });
        setModalTitle(`Comprobante de Convenio - Préstamo #${selectedPrestamo.idPrestamo}`);
        setModalError('');
        setShowComprobanteModal(true);
      }
    } catch (error) {
      console.error('Error:', error);
      toast.error(error.message || 'Error al registrar el convenio');
    } finally {
      setLoading(false);
    }
    
    if (selectedCliente) {
      handleSelectCliente(selectedCliente);
    }
  };

  const handleConfirm = (action) => {
    if (confirmationAction === 'pagar-cuota') {
      registrarPagoCuota();
    } else if (confirmationAction === 'reducir-mora') {
      registrarReducirMora();
    } else if (confirmationAction === 'cancelar-prestamo') {
      registrarCancelacionPrestamo();
    } else if (confirmationAction === 'reprogramar-prestamo') {
      registrarReprogramacion();
    } else if (confirmationAction === 'convenio-prestamo') {
      registrarConvenio();
    }
  };
  const handleReset = () => {
    setSearchQuery('');
    setSearchResults([]);
    setSelectedCliente(null);
    setCuotasPendientes([]);
    setSelectedCuota(null);
    setSelectedPrestamo(null);
    setSelectedPrestamoCuotas([]);
    setFormData({
      idCuota: '',
      idCliente: '',
      monto_pagado: '',
      numero_operacion: '',
      observaciones: ''
    });
    setCancelarForm({
      idPrestamo: '',
      idCliente: '',
      monto_pagado: '',
      numero_operacion: '',
      observaciones: ''
    });
    setReprogramarForm({
      idPrestamo: '',
      tasa_interes: '1',
      observaciones: ''
    });
    setConvenioForm({
      idPrestamo: '',
      solo_capital: false,
      excluir_mora: false,
      cuotas_convenio: '',
      fecha_inicio: '',
      frecuencia: '',
      tasa_interes: '1',
      observaciones: ''
    });
    setErrors({});
    setModalContent({ capturaUrl: '', comprobanteUrl: '' });
    setModalTitle('');
    setModalError('');
  };
  const handleInputChange = (e, formType) => {
    const { name, value, type, checked } = e.target;
    if (formType === 'cuota') {
      setFormData(prev => ({ ...prev, [name]: value }));
    } else if (formType === 'reducir-mora') {
      setFormData(prev => ({ ...prev, [name]: value }));
    } else if (formType === 'cancelar') {
      setCancelarForm(prev => ({ ...prev, [name]: value }));
    } else if (formType === 'reprogramar') {
      setReprogramarForm(prev => ({ ...prev, [name]: value }));
    } else if (formType === 'convenio') {
      setConvenioForm(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
    }
  };

  const isEligibleForReprogramacion = (prestamo) => {
    const hayCuotaConConvenio = prestamo.cuotas.some(
      cuota => cuota.estado === 'vencido' && cuota.dias_mora > 8);
    const hayCuotaPendiente = prestamo.cuotas.some(
      cuota => !['pagado', 'prepagado'].includes(cuota.estado));
    return !hayCuotaConConvenio && hayCuotaPendiente;
  };

  const isEligibleForConvenio = (prestamo) => {
    return prestamo.cuotas.some(
      cuota => !['pagado', 'prepagado'].includes(cuota.estado));
  };

  const isCuotaPagable = (prestamo, cuota) => {
    const sortedCuotas = prestamo.cuotas.sort((a, b) => a.numero_cuota - b.numero_cuota);
    const previousCuotas = sortedCuotas.filter(c => c.numero_cuota < cuota.numero_cuota);
    const allPreviousPaid = previousCuotas.every(c => c.estado === 'pagado');
    const isCurrentUnpaid = !['pagado', 'prepagado'].includes(cuota.estado);
    return allPreviousPaid && isCurrentUnpaid;
  };

  const formatDate = (dateString) => {
    try {
      const date = parseISO(dateString);
      return format(date, 'dd/MM/yyyy');
    } catch (error) {
      console.error('Error formatting date:', dateString, error);
      return '-';
    }
  };

  const handleCloseCapturaModal = () => {
    setShowCapturaModal(false);
    setModalContent({ capturaUrl: '', comprobanteUrl: '' });
    setModalTitle('');
    setModalError('');
    setSelectedCuota(null);
  };

  const handleCloseComprobanteModal = () => {
    setShowComprobanteModal(false);
    setModalContent({ capturaUrl: '', comprobanteUrl: '' });
    setModalTitle('');
    setModalError('');
    setSelectedCuota(null);
  };

  return (
    <div className="w-full h-full overflow-auto pb-16">
      {loading && <LoadingScreen />}

      <div className="ui-card mx-auto w-full p-4 sm:p-6 md:p-8">
        <div className="mb-5 border-b border-slate-200 pb-4">
          <p className="text-xs font-semibold uppercase tracking-[0.22em] text-red-600">Gestión de pagos</p>
          <h2 className="mt-2 text-xl font-semibold text-slate-900 sm:text-2xl">Registro de cuotas de préstamos</h2>
        </div>

        <ClienteSearch
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          handleSearch={handleSearch}
          handleReset={handleReset}
          searchResults={searchResults}
          handleSelectCliente={handleSelectCliente}
        />

        {selectedCliente && searchResults.length === 0 && (
          <PrestamosList
            selectedCliente={selectedCliente}
            cuotasPendientes={cuotasPendientes}
            isEligibleForReprogramacion={isEligibleForReprogramacion}
            isEligibleForConvenio={isEligibleForConvenio}
            isCuotaPagable={isCuotaPagable}
            formatDate={formatDate}
            handlePagarCuota={handlePagarCuota}
            handleVerCaptura={handleVerCaptura}
            handleVerComprobante={handleVerComprobante}
            handleVerComprobantesMultiples={handleVerComprobantesMultiples}
            handleCancelarPrestamo={handleCancelarPrestamo}
            handleReprogramarPrestamo={handleReprogramarPrestamo}
            handleConvenioPrestamo={handleConvenioPrestamo}
            handleSubirCapturaAbono={handleSubirCapturaAbono}
            handleReducirMora={handleReducirMora}
          />
        )}
      </div>

      <PagoCuotaModal
        show={showCuotaModal}
        onClose={() => setShowCuotaModal(false)}
        selectedCuota={selectedCuota}
        selectedPrestamo={selectedPrestamo}
        formData={formData}
        errors={errors}
        handleInputChange={(e) => handleInputChange(e, 'cuota')}
        handleConfirmAction={() => handleConfirmAction('pagar-cuota')}
        formatDate={formatDate}
      />

      <CapturaModal
        show={showCapturaModal}
        onClose={handleCloseCapturaModal}
        modalTitle={modalTitle}
        modalContent={modalContent}
        modalError={modalError}
        selectedCuota={selectedCuota}
        selectedCliente={selectedCliente}
        selectedPrestamo={selectedPrestamo}
        handleConfirmarPagoPrepagado={handleConfirmarPagoPrepagado}
        handleRechazarPagoPrepagado={handleRechazarPagoPrepagado}
      />

      <ComprobanteModal
        show={showComprobanteModal}
        onClose={handleCloseComprobanteModal}
        modalTitle={modalTitle}
        modalContent={modalContent}
        modalError={modalError}
        selectedCuota={selectedCuota}
        handleConfirmarPagoPrepagado={handleConfirmarPagoPrepagado}
      />

      <ComprobantesParcialesModal
        show={showComprobantesParcialesModal}
        onClose={() => setShowComprobantesParcialesModal(false)}
        cuota={pagosMultiples.cuota}
        prestamo={pagosMultiples.prestamo}
        pagos={pagosMultiples.pagos}
        loading={loadingComprobantes}
      />

      <CancelarPrestamoModal
        show={showCancelarModal}
        onClose={() => setShowCancelarModal(false)}
        selectedPrestamo={selectedPrestamo}
        cancelarForm={cancelarForm}
        errors={errors}
        handleInputChange={(e) => handleInputChange(e, 'cancelar')}
        handleFechaPagoChange={handleCancelarFechaPagoChange}
        calculandoMonto={calculandoMontoCancelacion}
        handleConfirmAction={() => handleConfirmAction('cancelar-prestamo')}
      />

      <ReprogramarPrestamoModal
        show={showReprogramarModal}
        onClose={() => setShowReprogramarModal(false)}
        selectedPrestamo={selectedPrestamo}
        reprogramarForm={reprogramarForm}
        errors={errors}
        handleInputChange={(e) => handleInputChange(e, 'reprogramar')}
        handleConfirmAction={() => handleConfirmAction('reprogramar-prestamo')}
      />

      <ConvenioPrestamoModal
        show={showConvenioModal}
      onClose={() => setShowConvenioModal(false)}
      selectedPrestamo={selectedPrestamo}
      convenioForm={convenioForm}
      errors={errors}
      totals={convenioTotals}
      handleInputChange={(e) => handleInputChange(e, 'convenio')}
      handleConfirmAction={() => handleConfirmAction('convenio-prestamo')}
    />

      <CapturaAbonoModal
        show={showCapturaAbonoModal}
        onClose={() => setShowCapturaAbonoModal(false)}
        clienteId={selectedCliente?.idUsuario}
        prestamoId={selectedPrestamo?.idPrestamo}
        modalTitle={`Subir Captura de Abono - Préstamo #${selectedPrestamo?.idPrestamo}`}
      />

      <ReducirMoraModal
        show={showReducirMoraModal}
        onClose={() => setShowReducirMoraModal(false)}
        selectedCuota={selectedCuota}
        selectedPrestamo={selectedPrestamo}
        formData={formData}
        errors={errors}
        handleInputChange={(e) => handleInputChange(e, 'reducir-mora')}
        handleConfirmAction={() => handleConfirmAction('reducir-mora')}
        formatDate={formatDate}
      />

      <ConfirmationModal
        show={showConfirmationModal}
        onClose={() => setShowConfirmationModal(false)}
        confirmationAction={confirmationAction}
      formData={formData}
      cancelarForm={cancelarForm}
      reprogramarForm={reprogramarForm}
      convenioForm={convenioForm}
      convenioTotals={convenioTotals}
      handleConfirm={handleConfirm}
    />
    </div>
  );
}


